<template>
	<footer class="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 border-t border-surface px-6 py-4 text-sm">
		<span class="font-medium">Evergreen Sports</span>
		<router-link to="/support" class="underline-offset-4 hover:underline">Support</router-link>
		<router-link to="/privacy-policy" class="underline-offset-4 hover:underline">Privacy policy</router-link>
		<router-link to="/account-deletion" class="underline-offset-4 hover:underline">Account deletion</router-link>
	</footer>
</template>
